<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" :size="mobileVersion ? 'fs' : 'lg-fix-h'">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{ $t('invoices.dialogs.upload_invoice_header') }}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 overflow-x-auto"
        :style="mobileVersion ? 'height: 80vh;' : 'height: 60vh;'">
        <el-form ref="ruleForm" class="h-full flex flex-col" :model="form" :rules="rules">
          <div class="lg:mb-2" v-if="[3, 8].includes(role)">
            <label
              class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('clients.entity_name') }}</label>
            <el-form-item prop="ClienteID" class="mb-0">
              <base-el-select class="w-full" :options="clientes" v-model="form.ClienteID" filterable clearable @change="handleChangeClienteId" />
            </el-form-item>
          </div>
          <section>
            <div class="lg:mb-2" v-if="form.ClienteID">
              <div class="flex">
                <label
                  class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('app.forma_recepcion') }}</label>
                <base-tooltip-icon v-if="!hasAutoFacturaModule || !hasIOCRModule" size="sm" :content="receivedPgeTooltip" class="ml-2" />
              </div>
              <el-form-item prop="pgeType">
                <base-el-select class="w-full" :options="pgeTypesRecepcion" v-model="form.pgeType" filterable/>
              </el-form-item>
            </div>
            <div class="lg:mb-2" v-if="isOCRPGE && form.ClienteID">
              <label
                class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{  $t('invoices.cif_receptor') }}</label>
              <el-form-item prop="CifEmpresa">
                <base-el-select class="w-full" :options="CifsEmpresaAPS" v-model="form.CifEmpresa" filterable clearable :option-label="cifLabelOption" :option-value="cifValueOption" />
              </el-form-item>
            </div>
            <div class="lg:flex" v-if="form.ClienteID && (!isOCRPGE || form.CifEmpresa)">
              <div class="max-w-md">
                <div class="flex items-center mb-1">
                  <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon />{{
                    isOCRPGE ? $t('invoices.pdf_invoice') : $t('invoices.doc_factura') }}</label>
                  <base-tooltip-icon size="sm" :content="extensionTooltipFacturaApsMessage" class="ml-2 " />
                </div>
                <el-form-item prop="fileMain" ref="fileMainRef">
                  <div @dragenter="e => e.preventDefault()" @dragover="e => e.preventDefault()" @drop.prevent.stop="onFileMainDrop">
                    <Upload ref="uploadMain" id="fileMainSelector" class="bg-white dark:bg-darkblue-900"
                      :class="[isLower1024 ? 'custom-upload-cert' : 'custom-upload ']" :accept="receivedAcceptFiles"
                      drag action="#" :auto-upload="false" :on-remove="handleRemoveMain" :limit="ocrUploadLimitComputed" multiple
                      :on-change="handleChangeMain" :on-exceed="handleOnExceedMain" :file-list="form.fileMain">
                      <i class="el-icon-upload"></i>
                      <p v-if="form.fileMain.length" slot="default" class="el-upload__text"><em>{{ this.fileNameMain }}</em></p>
                      <div v-else slot="default" class="el-upload__text" v-safe-html="$tc('app.upload_default_no_file_text', ocrUploadLimitComputed)"></div>
                      <upload-file-item slot="file" slot-scope="{file}" :file="file" :actions="[{name: 'addattachment-border', handler: selectFile, show: showAddAttachments}]"
                        :hide-expand-action="file.validations && file.validations.some(v => v.type === ErrorType.DUPLICATED_FILE)" :deep="2" custom="!max-h-fit" @remove="handleRemoveMain" @click="selectFile" reverse-colors />
                    </Upload>
                  </div>
                </el-form-item>
              </div>
              <div v-if="selectedFile && !disableAdjuntos" class="file-attachments-container max-w-md">
                <div class="flex items-center mb-1" :style="{ width: itemWidth }">
                  <base-obligatory-icon class="invisible" />
                  <el-tooltip placement="top-end">
                    <div slot="content" class="max-w-sm max-h-500p overflow-auto">
                      {{ selectedFile.path || selectedFile.name }}
                    </div>
                    <span class="tooltip-icon__icon-wrap truncate">
                      <label class="text-sm font-semibold text-secondary-600 block truncate">{{ attachmentsText }}</label>
                    </span>
                  </el-tooltip>
                  <base-tooltip-icon-multiple size="sm" :content="extensionTooltipMessage" class="ml-2" />
                </div>
                <div ref="upload-file-wrap" class="px-2" :style="{ width: 'fit-content' }">
                  <el-form-item prop="file" ref="fileRef">
                    <div @dragenter="e => e.preventDefault()" @dragover="e => e.preventDefault()" @drop.prevent.stop="onFileDrop">
                      <Upload ref="uploadMain" id="fileSelector" class="bg-white dark:bg-darkblue-900" :show-file-list="false"
                        :class="[isLower1024 ? 'custom-upload-cert' : 'custom-upload ']" :accept="acceptAdjuntosExternos" drag
                        multiple action="#" :auto-upload="false" :on-remove="handleRemove" :limit="maxFilesAdjWithRequired"
                        :on-change="handleChange" :on-exceed="handleOnExceed" :file-list="form.file" :disabled="form.fileMain.length > 1 && false ">
                        <i class="el-icon-upload"></i>
                        <p v-if="form.file.length" class="el-upload__text"><em>{{ fileName }}</em></p>
                        <div v-else class="el-upload__text" v-safe-html="$tc('app.upload_default_no_file_text', maxFilesAdjWithRequired)"></div>
                      </Upload>
                      <div v-for="file in expandedFiles" :key="file.linkid + file.uid">
                        <upload-file-list v-if="file.linkid === selectedFile.linkid && file.uid === selectedFile.uid" :files="attachments.filter(efile => (efile.linkedfile && efile.linkedfile.linkid === file.linkid && efile.linkedfile.uid === file.uid))"
                          :actions="[{name: 'error', handler: clearRequiredFile, show: efile => efile.required && !efile.IsAlreadyProvided && !!efile.raw}, {name: 'addattachment-border', handler: selectRequiredFile, show: efile => efile.required && !efile.IsAlreadyProvided}]" :hide-default-item-actions-callback="efile => efile.required || efile.IsAlreadyProvided" 
                          :hide-status-item-callback="efile => !efile.required" @remove-file="handleRemove" :item-click-listener-callback="efile => efile.required && !efile.IsAlreadyProvided ? {click: selectRequiredFile} : {}" />
                      </div>
                    </div>
                  </el-form-item>
                </div>
              </div>
              <div v-if="form.file && form.file.length > 0" class="all-attachments-container w-full">
                <div class="flex items-center mb-1 invisible">
                  <label class="text-sm font-semibold text-secondary-600 block w-0 truncate">{{ $t('invoices.all_documents_adj') }}</label>
                </div>
                <upload-file-list key="attachments-list" class="grid gap-4" :class="allAttachmentsListClass" :files="attachments" max-height="calc(100% - 20px)" :hide-status-item-callback="efile => !efile.required" hide-default-actions />
              </div>
            </div>
            <el-switch v-if="multiSend" class="switch-text break-normal" v-model="form.sendMail" :active-text="$t('app.send_mail')"></el-switch>
          </section>

        </el-form>
      </div>
    </template>
    <template slot="footer">
      <div class="flex flex-row w-full justify-between">
        <base-button class="w-full mx-2" @click="toggleDialog" mode="secondary-phantom-blue" :text="$t('app.cancel')" />
        <base-button :disabled="disableSubmit" :loading="isLoadingUpdate" mode="secondary-phantom-blue" class="w-full mx-2"
          :text="$tc('invoices.dialogs.upload_invoice', 1)" @click="submitForm('ruleForm')" />
      </div>
    </template>
  </base-dialog-button>
</template>

<script>
import UploadDocumentMixin, { WarningType, ErrorType } from '@/mixins/UploadDocumentMixin'

import { getClients } from '@/services/clients/getClients'
import { getAvailableCifsAPS } from '@/services/companies/getAvailableCifsAPS'

import { subirFacturaAPS } from '@/services/invoices/subirFacturaAPS'
import { subirFacturaRecibida } from '@/services/invoices/subirFacturaRecibida'

import { Upload } from 'element-ui'
import { i18n } from '@/i18n'
import { EXTENSIONES_ADJ_EXTERNOS, EXTENSIONES_ADJ_EXTERNOS_FACEB2B } from '@/config/extensiones-adj-externos'
import { EXTENSIONES_FACTURAE } from '@/config/extensiones-facturae'
import UploadFileItem from '@/components/UploadFileItem.vue'
import UploadFileList from '@/components/UploadFileList.vue'

export default
{
  name: 'upload-received-invoice-dialog',
  mixins: [UploadDocumentMixin],
  components: {
    Upload,
    UploadFileItem,
    UploadFileList,
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    mobileVersion: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      WarningType,
      ErrorType,
      isLoadingUpdate: false,
      loading: false,
      isOpen: this.dialogOpen,
      itemWidth: 'fit-content',
      form: {
        ClienteID: '',
        CifEmpresa: '',
        fileMain: [],
        file: [],
        sendMail: false,
        pgeType: '',
      },
      selectCif: '',
      selectPge: '',
      currentSchema: '',
      selectedFile: null,
      ocrUploadLimit: 30,
      maxFilesAdj: 5,
      maxApsSizeFile: 7340032, // Bytes (7MB)
      clientes: [],
      CifsEmpresaAPS: [],
      extensionesAdjuntosPermitidas: EXTENSIONES_ADJ_EXTERNOS,
      extensionesAdjuntosFaceb2b: EXTENSIONES_ADJ_EXTERNOS_FACEB2B,
      extensionesFacturaePermitidas: EXTENSIONES_FACTURAE,
      rules: {
        ClienteID: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change'],
          }
        ],
        CifEmpresa: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change'],
          }
        ],
        fileMain: [
          {
            required: true,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (!this.fileNameMain) {
                callback(new Error(i18n.t('app.fill_data')))
              } else {
                callback()
              }
            }
          },
          {
            required: true,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.fileNameMain) {
                const totalSize = this.form.fileMain.map(x => x.size).reduce((a, b) => a + b, 0)
                if (totalSize > this.maxApsSizeFile) {
                  callback(new Error(i18n.t('validation.exceed_size_files_total') + ' (' + this.maxMBAdj + ' MB)'))
                } else {
                  callback()
                }
              }
            }
          },
          {
            required: true,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              const validExts = [...(this.isOCRPGE ? ['PDF'] : ['XML', 'XSIG']), 'ZIP']
              if (!this.fileNameMain || this.fileNameMain.length < 5 || !this.fileNamesMain.every(name => validExts.includes(this.getExtensionFromFileName(name).toUpperCase()))) {
                return callback(new Error(i18n.t('validation.not_valid_extension', { exts: validExts })))
              }
              callback()
            }
          },
          {
            required: true,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              const exts = this.fileNamesMain.map(name => this.getExtensionFromFileName(name).toUpperCase())
              if (exts.some(x => x === 'ZIP')) {
                if (exts.length > 1) {
                  return callback(new Error(i18n.t('validation.onlyonce_zip')))
                }
              } else if (this.isOCRPGE) {
                if (!exts.every(x => x === 'PDF')) {
                  return callback(new Error(i18n.t('validation.not_single_valid_extension', { ext: '.pdf' })))
                }
              } else if (!exts.every(x => ['XML', 'XSIG'].includes(x))) {
                return callback(new Error(i18n.t('validation.not_single_valid_extension', { ext: this.listToCommaString(['.xml', '.xsig'], true) })))
              }
              callback()
            }
          },
        ],
        file: [
          {
            required: true,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.isOCRPGE && this.form.file.length > 0) {
                callback(new Error(i18n.t('validation.no_attachments_permited')))
              } else {
                callback()
              }
            }
          },
          {
            required: true,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.fileName) {
                let totalSize = 0
                this.form.file.forEach(x => {
                  totalSize = totalSize + x.size
                })
                if (totalSize > this.maxApsSizeFile) {
                  callback(new Error(i18n.t('validation.exceed_size_files_total') + ' (' + this.maxMBAdj + ' MB)'))
                } else {
                  callback()
                }
              } else {
                callback()
              }
            }
          },
          {
            required: true,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.form.file.some(archivo => !this.extensionesAdjuntosPermitidas.includes(this.getExtensionFromFileName(archivo.name).toUpperCase()))) {
                callback(new Error(this.extensionRuleMessage))
              } else {
                callback()
              }
            }
          },
        ]
      },
      schemasFiles: {
        EFR: 0,
        FACTURAE: 0,
        NO_VALID: 0,
      },
    }
  },
  watch: {
    // Inicializar al abrir el componente
    'form.pgeType': function (value, oldValue) {
      if (value !== oldValue && (this.isOCRPGE)) {
        this.selectedFile = null
        this.resetFormFiles()
      }
    },
    selectCif: function (value, oldValue) {
      if (value !== oldValue) {
        this.form.CifEmpresa = value || ''
      }
    },
    selectPge: function (value, oldValue) {
      if (value !== oldValue) {
        this.form.pgeType = value || ''
      }
    },
  },
  mounted: async function () {
  },
  computed: {
    SchemaForType: function () {
      return this.tiposEsquema.filter(x => x.types.includes('received')).map(x => x.esquema)
    },
    isOCRPGE: function () {
      return this.form.pgeType === 'OCR' || this.form.pgeType === 'OCRIA'
    },
    disableSubmit: function () {
      var disable = Object.values(this.form).filter(x => typeof x !== 'boolean').reduce((a, b) => a || (!b && b !== 0), false)

      disable ||= this.form.fileMain.some(file => file.validations?.some(validation => !validation.fixed) || file.files?.some(efile => efile.validations?.some(validation => !validation.fixed)))
      disable ||= this.form.fileMain.some(file => file.warns?.some(warn => !warn.fixed) || file.files?.some(efile => efile.warns?.some(warn => !warn.fixed)))
      disable ||= this.isOCRPGE && !this.form.CifEmpresa

      return this.isLoadingUpdate || disable
    },
    ocrUploadLimitComputed: function () {
      return this.form.fileMain.some(x => this.getExtensionFromFileName(x.name).toUpperCase() === 'ZIP') ? 1 : this.ocrUploadLimit
    },
    
    receivedAcceptFiles: function () {
      const exts = this.fileNamesMain.map(name => this.getExtensionFromFileName(name).toUpperCase())
      const validMimeTypes = this.isOCRPGE ? ['application/pdf'] : ['.xml', '.xsig']

      if (exts.length === 0) {
        return validMimeTypes.concat('.zip').join(',')
      }
      if (exts.some(x => x === 'ZIP')) {
        return '.zip'        
      }
      return validMimeTypes.join(',')
    },
    disableAdjuntos () {
      return this.isOCRPGE
    },
    acceptAdjuntosExternos () {
      if (this.form.pgeType === 'FACEB2B') return '.xml,.xsig,application/pdf,application/zip'
      return '.pdf,.html'
    },
    maxMBAdj () {
      return this.maxApsSizeFile / 1024 / 1024
    },
    extensionRuleMessage: function () {
      if (this.form.pgeType === 'FACEB2B') {
        return `${i18n.t('validation.not_extension', { exts: this.extensionesAdjuntosFaceb2b.join(', ') })} ${i18n.t('validation.onlyonce_zip')}`
      }
      return i18n.t('validation.not_extension', { exts: this.extensionesAdjuntosPermitidas.join(', ') })
    },
    extensionTooltipMessage: function () {
      var maxFileMsg = this.form.pgeType === 'FACEB2B' ? i18n.t('validation.max_files_faceb2b', { maxFilesAdj: this.maxFilesAdj }) : i18n.t('validation.max_files', { maxFilesAdj: this.maxFilesAdj })
      var maxSizeMsg = i18n.t('validation.max_size_files', { maxMBAdj: this.maxMBAdj })
      var lines = [maxFileMsg + ' ' + maxSizeMsg]
      if (this.form.pgeType === 'FACEB2B') {
        lines.push(i18n.t('validation.extension', { exts: this.extensionesAdjuntosFaceb2b.join(', ') }))
      } else {
        lines[0] += ' ' + i18n.t('validation.extension', { exts: this.extensionesAdjuntosPermitidas.join(', ') })
      }
      return lines
    },
    extensionTooltipFacturaApsMessage: function () {
      const validExts = this.receivedAcceptFiles.split(',').map(x => x.replace(/application\/|\./, ''))
      return `${i18n.t('tooltip.total_max_size_files', { maxMB: this.maxMBAdj })} ${i18n.t('validation.extension', { exts: validExts.join(', ') })}`
    },
    attachmentsText () {
      if (this.selectedFile?.path) {
        return this.$t('invoices.documents_adj_of', { name: this.selectedFile.path })
      }
      if (this.selectedFile?.name) {
        return this.$t('invoices.documents_adj_of', this.selectedFile)
      }
      return this.$t('invoices.documents_adj')
    },
    
    hasOCRIAModule: function () {
      return this.$store.getters['auth/hasOCRIAIntegrationModule']
    },
    hasIOCRModule: function () {
      return this.$store.getters['auth/hasOCRIntegrationModule']
    },
    hasAutoFacturaModule: function () {
      return this.$store.getters['auth/hasAutofacturaModule']
    },
    receivedPgeTooltip: function () {
      const modules = []
      const tiposPges = this.$store.getters['config/TIPOS_PGE_RECEPCION']
      if (!this.hasAutoFacturaModule) {
        modules.push(tiposPges.find(x => x.id === 'AUTOFACTURA').name)
      }
      if (!this.hasIOCRModule) {
        modules.push(tiposPges.find(x => x.id === 'OCR').name)
      }
      return i18n.tc('tooltip.received_pge_warn', modules.length, { module: modules.join(', ') })
    },
    pgeTypesRecepcion: function () {
      const tiposPges = this.$store.getters['config/TIPOS_PGE_RECEPCION']
      const pgeOCRIA = this.$store.getters['config/TIPOS_PGE_RECEPCION_IA']
      const pges = [tiposPges.find(x => x.id === 'MANUAL')]
      if (this.hasAutoFacturaModule) {
        pges.push(tiposPges.find(x => x.id === 'AUTOFACTURA'))
      }
      if (this.hasIOCRModule) {
        pges.push(tiposPges.find(x => x.id === 'OCR'))
      }
      if (this.hasOCRIAModule) {
        pges.push(pgeOCRIA.find(x => x.id === 'OCRIA'))
      }
      return pges
    },
  },
  methods: {
    getSchemaRequestParams (idCliente) {
      const params = { isReceived: true }
      if ([3, 8].includes(this.role)) params.idCliente = idCliente
      return params
    },
    handleChangeClienteId: async function (ClienteID) {
      if (ClienteID) {
        this.updateClientAPSCifs(ClienteID)
        this.updateSchemaFiles(ClienteID)
      } else {
        this.CifsEmpresaAPS = []
      }
    },
    handleChangeMain: async function (archivo) {
      (this.$refs.fileMainRef).clearValidate()
      let fileOk = true
      const exts = this.fileNamesMain.map(name => this.getExtensionFromFileName(name).toUpperCase()).concat(this.getExtensionFromFileName(archivo.name).toUpperCase())
      if (exts.some(x => x === 'ZIP')) {
        if (exts.length > 1) {
          this.doFeedback(i18n.t('validation.onlyonce_zip'))
          this.handleRemoveMain(archivo)
          fileOk = false
        } else {
          await this.checkSchemaZipFile(archivo)
        }
      } else if (!this.isOCRPGE) {
        if (!['XML'].includes(this.getExtensionFromFileName(archivo.name).toUpperCase())) {
          this.doFeedback(i18n.t('validation.not_single_valid_extension', { ext: '.xml' }))
          this.handleRemoveMain(archivo)
          fileOk = false
        } else {
          await this.checkSchemaFile(archivo)
          if ((this.form.fileMain.length + 1) === 1 && !archivo.files?.length && !archivo.validations?.length) {
            this.selectFile(archivo)
          }
        }
      } else if (!['PDF'].includes(this.getExtensionFromFileName(archivo.name).toUpperCase())) {
        this.doFeedback(i18n.t('validation.not_single_valid_extension', { ext: '.pdf' }))
        this.handleRemoveMain(archivo)
        fileOk = false
      }
      
      if (fileOk) {
        this.form.fileMain.push(archivo)
      }
    },
    handleChange: function (archivo) {
      this.$refs.fileRef.clearValidate()

      const extension = this.getExtensionFromFileName(archivo.name).toUpperCase()
      var error = false
      if (this.form.pgeType === 'FACEB2B') {
        if (!this.extensionesAdjuntosFaceb2b.includes(extension)) {
          error = i18n.t('validation.not_valid_extension', { exts: this.extensionesAdjuntosFaceb2b.join(', ') })
        }
        if ((extension === 'ZIP' || this.form.file.map(x => this.getExtensionFromFileName(x.name).toUpperCase()).includes('ZIP')) && this.form.file.length >= 1) {
          error = i18n.t('validation.not_faceb2b_zip')
        }
      } else {
        if (!this.extensionesAdjuntosPermitidas.includes(extension)) {
          error = i18n.t('validation.not_valid_extension', { exts: this.extensionesAdjuntosPermitidas.join(', ') })
        }
      }
      if (error && error !== '') {
        this.doFeedback(error)
        this.handleRemove(archivo)
      } else {
        if (this.selectedFile) {
          this.$set(archivo, 'linkedfile', this.selectedFile)
        } else if (this.form.fileMain.length === 1) {
          this.$set(archivo, 'linkedfile', this.form.fileMain[0])
        }
        const mainFile = this.expandedFiles.find(x => x.linkid === archivo.linkedfile.linkid && x.uid === archivo.linkedfile.uid)
        if (mainFile?.reqAttachments?.some(x => x.AttachmentFormalName === archivo.name)) {
          const requireds = mainFile.reqAttachments.filter(x => x.AttachmentFormalName === archivo.name)
          const attachment = this.form.file.find(x => requireds.some(required => x.attachmentid === required.UniqueIdentifierAttachment) && !x.raw)
          if (attachment) {
            this.$set(attachment, 'successmsg', archivo?.name)
            this.$set(attachment, 'showinfo', !archivo?.raw)
            this.$set(attachment, 'raw', archivo.raw)
            this.expandedFiles.filter(x => x.linkid === attachment.linkedfile.linkid).forEach(x => this.$set(x, 'showinfo', this.form.file.filter(att => att.linkedfile.linkid === x.linkid).some(att => att.showinfo)))
            this.updateAttachmentWarningStatus(WarningType.MISSING_ATTACHMENT, !!archivo.raw, file => file.attachmentid === attachment.attachmentid, warn => warn.attachmentid === attachment.attachmentid)
            this.handleRemove(archivo)
          } else {
            const attachmentExt = this.getExtensionFromFileName(requireds[0].UniqueIdentifierAttachment)
            const attachmentKey = requireds[0].UniqueIdentifierAttachment.substring(0, requireds[0].UniqueIdentifierAttachment.lastIndexOf('.'))
            const attachmentCount = this.form.file.filter(x => x.name === archivo.name && x.linkedfile.linkid === archivo.linkedfile.linkid && x.linkedfile.uid === archivo.linkedfile.uid).length
            this.$set(archivo, 'attachmentid', `${attachmentKey}_${attachmentCount}.${attachmentExt}`)
            this.$set(archivo, 'origin', `user.${archivo.uid}`)
            this.form.file.push(archivo) 
          }
        } else {
          this.$set(archivo, 'origin', `user.${archivo.uid}`)
          this.form.file.push(archivo) 
        }
      }
    },
    handleOnExceedMain: function () {
      this.doFeedback(i18n.t('validation.max_files_warn', { limit: this.isRecibida ? this.ocrUploadLimitComputed : this.pgeUploadLimitComputed }), 'warning')
    },
    handleOnExceed: function () {
      this.doFeedback(i18n.t('validation.max_files_warn', { limit: this.maxFilesAdj }), 'warning')
    },
    handleRemoveMain: function (file) {
      this.form.fileMain = this.form.fileMain.filter(x => x.uid !== file.uid)
      const isZipFile = file.linkid === 'ZIPFILE'
      if (file.esquema) {
        if (file.esquema === 'Variado') {
          if (file.files?.length) {
            file.files.forEach(x => { if (x.esquema) { this.schemasFiles[x.esquema] = Math.max(this.schemasFiles[x.esquema] - 1, 0) } })
          }
        } else {
          let n = 1
          let esquema = file.esquema
          if (isZipFile) {
            n = file.files?.length ?? 0
            esquema = file.esquema.slice(0, -1)
          }
          this.schemasFiles[esquema] = Math.max(this.schemasFiles[esquema] - n, 0)
          if (this.schemasFiles[esquema] < 1 && this.currentSchema === esquema) {
            let schema = ''
            this.updateValidationStatus(ErrorType.MISCELANEUS_SCHEMA_ERROR, efile => (schema ||= (efile.esquema && efile.esquema !== 'NO_VALID' ? efile.esquema : '')) === efile.esquema)
            this.currentSchema = schema
          }
        }
      }
      const matchCif = isZipFile 
        ? file.files.some(efile => this.selectCif === efile.IdCifEmpresa) 
        : this.selectCif === file.IdCifEmpresa
      if (this.selectCif && matchCif && !this.expandedFiles.some(efile => efile.IdCifEmpresa === this.selectCif)) {
        let idCIFEmpresa = ''
        this.updateValidationStatus(ErrorType.MISCELANEUS_CIF_ERROR, efile => (idCIFEmpresa ||= (efile.IdCifEmpresa && efile.esquema === this.currentSchema ? efile.IdCifEmpresa : '')) === efile.IdCifEmpresa)
        this.selectCif = idCIFEmpresa
      }
      const matchPge = isZipFile 
        ? file.files.some(efile => this.selectPge === efile.pgeType) 
        : this.selectPge === file.pgeType
      if (this.selectPge && matchPge && !this.expandedFiles.some(efile => efile.pgeType === this.selectPge)) {
        let pgeType = ''
        this.updateValidationStatus(ErrorType.MISCELANEUS_PGE_ERROR, efile => (pgeType ||= (efile.pgeType && efile.esquema === this.currentSchema ? efile.pgeType : '')) === efile.pgeType)
        this.selectPge = pgeType
      }
      if (this.selectedFile?.linkid === file.linkid && this.selectedFile?.uid === file.uid) {
        this.selectedFile = null
      }
      if (file.files?.length) {
        for (const efile of file.files) {
          if (this.selectedFile?.linkid === efile.linkid && this.selectedFile?.uid === efile.uid) {
            this.selectedFile = null
          }
        }
      }
      this.form.file.filter(x => x.linkedfile.uid === file.uid).forEach(x => this.handleRemove(x))
      const duplicated = this.form.fileMain.filter(x => x.linkid === file.linkid)
      if (duplicated.length) {
        if (duplicated.every(x => x.validations?.some(v => v.type === ErrorType.DUPLICATED_FILE))) {
          this.updateValidationStatus(ErrorType.DUPLICATED_FILE, true, efile => efile.uid === duplicated[0].uid)
        }
      }
    },

    // #region CheckSchema Methods
    checkSchemaFileResponse (archivo, fileData) {
      const fileName = this.initializeSchemaFileResponse(archivo, fileData)

      if (!this.SchemaForType.includes(fileData.esquema)) {
        const msg = `${fileName}: ${i18n.t('feedback.error.not_valid_schema_for_tab_error', { fileType: i18n.t('invoices.received_header') })}`
        setTimeout(() => this.doFeedback(msg), 100)
        this.addValidation(archivo, msg, ErrorType.SCHEMA_TYPE_ERROR)
        this.selectFile(archivo, true)
      }

      if (fileData.esquema !== 'FACTURAE' && !this.isOCRPGE) {
        const msg = `${fileName}: ${i18n.t('feedback.error.not_valid_schema_for_error', { pge: this.form.pgeType })}`
        setTimeout(() => this.doFeedback(msg), 100)
        this.addValidation(archivo, msg, ErrorType.SCHEMA_TYPE_ERROR)
        this.selectFile(archivo, true)
      }
      
      this.registerFileSchema(archivo, fileData)

      if (this.validateSchemaFileDetails(archivo, fileData, fileName)) {
        const validateNoMix = (value, selectedValue, message, errorType, target) => {
          if (value && selectedValue !== value) {
            setTimeout(() => this.doFeedback(message), 100)
            this.addValidation(target, message, errorType)
            this.selectFile(target, true)
          }
        }
        this.$set(archivo, 'isSigned', !!fileData.IsSigned)
        this.$set(archivo, 'IdCifEmpresa', fileData.IdCifEmpresaDetected || '')
        this.selectCif ||= archivo.IdCifEmpresa
        validateNoMix(
          archivo.IdCifEmpresa, 
          this.selectCif, 
          i18n.t('feedback.error.miscelaneus_cif_error'), 
          ErrorType.MISCELANEUS_CIF_ERROR, 
          archivo
        )

        const invoices = fileData.FileDetails.Invoices || []
        const hasMultipleInvoices = fileData.FileDetails.InvoicesToImport > 1
        const isMultipleFile = !!(this.tiposEsquema.find(x => x.esquema === fileData.esquema)?.multiple ?? false)
        if (hasMultipleInvoices) {
          this.$set(archivo, 'files', [])
          this.$set(archivo, 'isOpen', false)
        }
          
        for (const invoice of invoices) {
          const innerfile = hasMultipleInvoices ? {} : archivo
          this.$set(innerfile, 'pgeType', invoice.SendTypeSelected || '')
          this.selectPge ||= innerfile.pgeType
          validateNoMix(
            innerfile.pgeType, 
            this.selectPge, 
            i18n.t('feedback.error.miscelaneus_pge_error'), 
            ErrorType.MISCELANEUS_PGE_ERROR, 
            innerfile
          )
          if (isMultipleFile) {
            const idprop = hasMultipleInvoices ? 'linkid' : 'attachid'
            this.$set(innerfile, idprop, `${archivo.linkid}_${invoice.UniqueIdentifierInvoice}`)
            this.$set(innerfile, 'uid', archivo.uid)
            this.$set(innerfile, 'origin', `user.api.invoice.${innerfile.uid}`)
            this.$set(archivo, 'pgeType', archivo.pgeType || invoice.SendTypeSelected || '')
            this.$set(innerfile, 'IdCifEmpresa', fileData.IdCifEmpresaDetected || '')
            if (hasMultipleInvoices) {
              const name = invoice.InvoiceSeries
                ? `${invoice.InvoiceSeries}_${invoice.InvoiceNumber}`
                : `${invoice.InvoiceNumber}`
  
              this.$set(innerfile, 'name', name)
            }
          }
          this.$set(innerfile, 'reqAttachments', invoice.RequestedAttachments)
          this.checkAttachmentsFileResponse(innerfile, invoice.RequestedAttachments)
          if (hasMultipleInvoices)archivo.files.push(innerfile)
        }
          
        if (hasMultipleInvoices && archivo.files?.some(x => x.warns?.length)) {
          this.addWarning(archivo, i18n.t('tooltip.issued_any_childfile_warns'), WarningType.MIXED_WARNING, archivo.files.every(x => x.warns?.every(w => w.fixed) ?? true))
        }
      }
      this.setSchemaChildPaths(archivo)
    },
    // #endregion

    showAddAttachments: function (efile) {
      return !this.disableAdjuntos && !efile.files?.length && (this.isFileSuccess(efile) || this.isFileWarn(efile))
    },
    resetForm: function () {
      this.resetFormFiles()
      this.form.CifEmpresa = ''
      this.form.pgeType = 'MANUAL'
      this.form.sendMail = false
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.clearValidate()
      }
    },
    initialiceData: async function () {
      this.resetAllForm()
      if ([8, 3].includes(this.role)) {
        const dataClients = await getClients()
        if (dataClients.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', dataClients))
        }
        this.clientes = dataClients.Clientes.map(x => ({ label: x.Nombre, value: x.idCliente }))
        this.form.ClienteID = this.clientFilter || ''
      } else {
        this.form.ClienteID = this.getIdEmpresaLogged || ''
      }
      if (this.form.ClienteID) {
        this.updateClientAPSCifs(this.form.ClienteID)
      }
      this.selectedFile = null
      this.selectCif = ''
      this.selectPge = ''
    },
    submitForm: async function (ruleForm) {
      const noWarnings = !this.warningError || (this.isWarningFixed(this.form.fileMain) && this.isWarningFixed(this.form.file))
      const noValidations = !this.validationError || (this.isValidationFixed(this.form.fileMain) && this.isValidationFixed(this.form.file))
      if (noValidations && noWarnings) {
        this.uploadInvoice(ruleForm)
      } else if (!noWarnings) {
        this.doFeedback(i18n.t('feedback.error.process_data_error'), 'warning')
      } else {
        this.doFeedback(i18n.t('feedback.error.process_data_error'))
      }
    },
    uploadInvoice: function (ruleForm) {
      try {
        this.$store.commit('setIsLoading', true)
        this.$refs[ruleForm].validate(async valid => {
          if (!valid) {
            this.doFeedback(i18n.t('feedback.error.process_data_error'))
            return
          }
          this.isLoadingUpdate = true
          let files
          if (this.disableAdjuntos) {
            files = this.form.fileMain
          } else {
            files = this.form.fileMain.concat(this.form.file)
          }
          const params = {
            idCIFEmpresa: this.form.CifEmpresa,
            pgeType: this.form.pgeType || 'MANUAL',
            multiSend: !!this.multiSend,
            enviarMail: !!this.form.sendMail,
            idCliente: 0,
          }
          if ([3, 8].includes(this.role)) {
            params.idCliente = this.form.ClienteID
          }
          if (this.isOCRPGE) {
            if (this.multiSend) {
              subirFacturaAPS(files, params).then(response => {
                if (response.blnError === true) {
                  this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response), response.codError === 'FCSF012' ? 'warning' : 'error')
                } else {
                  this.doFeedback(i18n.tc('feedback.success.invoices_uploaded_msg', 1), 'success')
                }
                this.$emit('applyDialog', { results: response.Respuestas })
              }).catch(() => {
                this.doFeedback(i18n.t('feedback.error.internal_error_message'))
                this.$emit('applyDialog', {})
              }).finally(() => { this.isLoadingUpdate = false })
              this.resetForm()
              this.resetSchemasFiles()
              this.$emit('applyDialog', { background: true })
            } else {
              const response = await subirFacturaAPS(files, params)
              if (response.blnError === true) {
                this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
              } else {
                this.resetForm()
                this.resetSchemasFiles()
                this.$emit('applyDialog', {})
                this.doFeedback(i18n.tc('feedback.success.invoices_uploaded_msg', 1), 'success')
              }
              this.isLoadingUpdate = false
            }
          } else {
            if (this.multiSend) {
              subirFacturaRecibida(files, params).then(response => {
                if (response.blnError === true) {
                  this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response), response.codError === 'FCSF012' ? 'warning' : 'error')
                } else {
                  this.doFeedback(i18n.tc('feedback.success.invoices_uploaded_msg', 1), 'success')
                }
                this.$emit('applyDialog', { results: response.Respuestas })
              }).catch(() => {
                this.doFeedback(i18n.t('feedback.error.internal_error_message'))
                this.$emit('applyDialog', {})
              }).finally(() => { this.isLoadingUpdate = false })
              this.resetForm()
              this.resetSchemasFiles()
              this.$emit('applyDialog', { background: true })
            } else {
              const response = await subirFacturaRecibida(files, params)
              if (response.blnError === true) {
                this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
              } else {
                this.resetForm()
                this.resetSchemasFiles()
                this.$emit('applyDialog', {})
                this.doFeedback(i18n.tc('feedback.success.invoices_uploaded_msg', 1), 'success')
              }
              this.isLoadingUpdate = false
            }
          }
        })
      } catch (error) {
        this.isLoadingUpdate = false
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    updateClientAPSCifs: async function (idCliente) {
      this.loading = true
      this.$store.commit('setIsLoading', true)
      this.form.CifEmpresa = ''
      const res = await getAvailableCifsAPS({ idCliente })
      if (res.blnError) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', res))
        this.CifsEmpresaAPS = []
      } else {
        this.CifsEmpresaAPS = res.CIFSEmpresa
      }
      this.loading = false
      this.$store.commit('setIsLoading', false)
    },
    cifLabelOption: function (option) {
      return option.RazonSocial
    },
    cifValueOption: function (option) {
      return option.IdCIFEmpresa
    },
  }
}
</script>

<style lang="scss" scoped>
#fileMainSelector::v-deep .el-upload-list {
  max-height: 67px !important;
}

::v-deep .el-upload-list__item:first-child {
  margin-top: 5px;
}

.upload-file-list {
  padding-bottom: 0;
}

.all-attachments-container .upload-file-list ::v-deep .upload-file-list--item {
  margin-top: unset;
  margin-bottom: unset;
}
.main-files-container, .file-attachments-container {
  height: fit-content;
}
.all-attachments-container {
  max-height: 345px;
}

.el-form-item {
  margin-bottom: 0;
}

@media (min-width: 1024px) {
  .all-attachments-container .upload-file-list.grid-cols-2 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .all-attachments-container .upload-file-list.grid-cols-3 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (min-width: 1680px) {
  .all-attachments-container .upload-file-list.grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .all-attachments-container .upload-file-list.grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
</style>
